<input
  [type]="to.type"
  [attr.aria-required]="to.required"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="op-input"
>
